import { Card, CardContent, Stack, Typography, useTheme, Box } from '@mui/material';
import MultiStatusChip from '../../../utils/utilities/MultiStatusChip';

import { relativeTime, formatGenericDateTime } from '../../../utils/util';

const getStatus = (stage) => {
    if (stage.completed_at) return 'completed';
    if (stage.received_at) return 'pending';
    return 'scheduled';
  };

const PrepStage = ({ stage, dense = false }) => {
  const { name, description, received_at, completed_at } = stage;

  const theme = useTheme();

  const status = getStatus(stage);

  // Status configuration
  const statusConfig = {
    scheduled: {
      borderColor: theme.palette.primary.soft, // Blue
      chipColor: 'primary',
      label: 'Scheduled'
    },
    pending: {
      borderColor: theme.palette.warning.soft, // Orange  
      chipColor: 'warning',
      label: 'In Progress'
    },
    completed: {
      borderColor: theme.palette.success.soft, // Green
      chipColor: 'success',
      label: 'Completed'
    }
  };

  const config = statusConfig[status];

  return (
    <Card 
      variant='outlined'
      sx={{
        // backgroundColor: config.color,
        borderColor: config.borderColor,
        borderLeft: `4px solid ${config.borderColor}`,
        // mb: 2,
        width: '100%',
      }}
    >
      <CardContent sx={{ p:1, pb: '.4rem !important' }}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={0}>
          <Typography variant="h6" component="h3" fontWeight="600">
            {name}
          </Typography>
      
          <MultiStatusChip value={status} values={[{value: "scheduled", label: "Scheduled", status: config.chipColor}, {value: "pending", label: "In Progress", status: config.chipColor}, {value: "completed", label: "Completed", status: config.chipColor}]} />
        </Stack>
        
        {description && (
          <Typography variant="body2" color="text.secondary" mb={1}>
            {description}
          </Typography>
        )}

        <Box>
          {received_at && (
            <Typography variant="caption" display="block" color="text.secondary">
              Received: &nbsp; {formatGenericDateTime(received_at)}
            </Typography>
          )}
          {completed_at && (
            <Typography variant="caption" display="block" color="text.secondary">
              Completed: &nbsp; {formatGenericDateTime(completed_at)}
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default PrepStage;